import { render } from "./DefaultProfile.vue?vue&type=template&id=1b2a7b14&scoped=true"
import script from "./DefaultProfile.vue?vue&type=script&lang=js"
export * from "./DefaultProfile.vue?vue&type=script&lang=js"

import "./DefaultProfile.vue?vue&type=style&index=0&id=1b2a7b14&scoped=true&lang=css"

import exportComponent from "/Users/parasagrawal/projects/twitter-helpdesk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2a7b14"]])

export default __exports__